<template>
    <div class="register-content">
        <div class="accounr-register" v-if="registerType=='account'">
            <div class="register-content-title">账号注册</div>
            <div class="register-content-tip"><i class="el-icon-warning-outline"></i> 如未收到邮箱验证码，请更换邮箱再试</div>
            <el-form :model="register" :rules="registerRules" ref="registerForm" name="register" key="register">
                <el-form-item prop="email">
                    <el-input
                        type="text"
                        name="email"
                        key="register-email-input"
                        placeholder="邮箱账号"
                        v-model="register.email"
                    />
                </el-form-item>
                <el-form-item prop="password">
                    <el-input
                        type="password"
                        name="password"
                        key="register-password-input"
                        placeholder="密码"
                        show-password
                        v-model="register.password"
                    />
                </el-form-item>
                <el-form-item prop="repassword">
                    <el-input
                        type="password"
                        name="repassword"
                        key="register-repassword-input"
                        placeholder="确认密码"
                        show-password
                        v-model="register.repassword"
                    />
                </el-form-item>
                <el-form-item prop="vcode">
                    <el-row>
                        <el-col :span="14">
                            <el-input
                                type="text"
                                name="vcode"
                                key="register-vcode-input"
                                placeholder="验证码"
                                v-model="register.vcode"
                            />
                        </el-col>
                        <el-col :span="9" :offset="1">
                            <el-button
                                type="primary"
                                style="width: 100%"
                                v-if="!vcodeIsSend"
                                :loading="vcodeBtnLoading"
                                @click="handleGetVcode"
                            >{{ vcodeBtnText }}</el-button>
                            <el-button
                                v-else
                                style="width: 100%"
                                disabled
                            >验证码已发送</el-button>
                        </el-col>
                    </el-row>
                </el-form-item>
                <div class="protocol">
                    <el-checkbox style="margin-right: 5px" v-model="register.protocol"></el-checkbox>
                    <div>我已阅读并接受<a href="http://www.shuzixs.com/#/blackboard/userAgreement" target="_blank">《用户协议》</a>和<a href="http://www.shuzixs.com/#/blackboard/privacyPolicy" target="_blank">《隐私政策》</a></div>
                </div>
                <el-button
                    type="primary"
                    style="width: 100%"
                    :loading="registerBtnLoading"
                    @click="handleRegister"
                >注册</el-button>
            </el-form>
        </div>
        <div class="email-register" v-if="registerType=='email'">
            <div class="register-content-title">邮箱注册</div>
            <el-form :model="register" :rules="registerRules" ref="registerForm" name="register" key="register">
                <el-form-item prop="email" class="login-form__item">
                    <el-input
                        type="text"
                        name="email"
                        key="register-email-input"
                        placeholder="邮箱账号"
                        v-model="register.email"
                    />
                </el-form-item>
                <el-form-item prop="vcode" class="login-form__item">
                    <el-row>
                        <el-col :span="14">
                            <el-input
                                type="text"
                                name="vcode"
                                key="register-vcode-input"
                                placeholder="验证码"
                                v-model="register.vcode"
                            />
                        </el-col>
                        <el-col :span="9" :offset="1">
                            <el-button
                                type="primary"
                                style="width: 100%"
                                v-if="!vcodeIsSend"
                                :loading="vcodeBtnLoading"
                                @click="handleGetVcode"
                            >{{ vcodeBtnText }}</el-button>
                            <el-button
                                v-else
                                style="width: 100%"
                                disabled
                            >验证码已发送</el-button>
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-form-item prop="password" class="login-form__item">
                    <el-input
                        type="password"
                        name="password"
                        key="register-password-input"
                        placeholder="密码"
                        show-password
                        v-model="register.password"
                    />
                </el-form-item>
                <el-form-item prop="repassword" class="login-form__item">
                    <el-input
                        type="password"
                        name="repassword"
                        key="register-repassword-input"
                        placeholder="确认密码"
                        show-password
                        v-model="register.repassword"
                    />
                </el-form-item>
                <el-button
                    type="primary"
                    style="width: 100%"
                    :loading="registerBtnLoading"
                    @click="handleRegister"
                >立即注册</el-button>
            </el-form>
        </div>
        <div class="login__button">
            <span @click="changePage(0)">账号登录</span>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import { getEmailCode, register } from '@/api/login';
    import { hasEmail } from '@/api/user';

    export default {
        name: 'DialogRegister',
        data() {
            const checkEmailIsRegister = (rule, value, callback) => {
                if (value.indexOf('.com') === -1) {
                    callback(new Error('请输入正确的国内邮箱地址'));
                    return ;
                }
                hasEmail({ email: value }).then(({ code, data }) => {
                    if (code === 0) {
                        if (data) {
                            callback(new Error('邮箱已注册'));
                        } else {
                            callback();
                        }
                    } else {
                        callback(new Error('请输入正确的国内邮箱地址'));
                    }
                }).catch(() => {
                    callback(new Error('请输入正确的国内邮箱地址'));
                });
            };
            const validateRegisterPassword = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入密码'));
                } else {
                    if (this.register.repassword !== '') {
                        this.$refs.registerForm.validateField('repassword');
                    }
                    callback();
                }
            };
            const validateRegisterRepassword = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请再次输入密码'));
                } else if (value !== this.register.password) {
                    callback(new Error('两次输入密码不一致'));
                } else {
                    callback();
                }
            };
            return {
                register: {
                    email: '',
                    password: '',
                    repassword: '',
                    vcode: '',
                    protocol: true
                },
                registerType:'email',
                registerRules: {
                    email: [
                        { required: true, message: '请输入邮箱', trigger: 'blur' },
                        { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] },
                        { validator: checkEmailIsRegister, trigger: 'blur' },
                    ],
                    password: [
                        { validator: validateRegisterPassword, trigger: 'blur' },
                        { min: 6, max: 20, message: '密码长度为6-20位', trigger: ['blur', 'change'] },
                        {
                            pattern: /^(?=.*[A-Z].*)(?=.*[a-z].*)[\S]{6,20}$/,
                            message: '至少输入一位大写字母和小写字母',
                            trigger: ['blur', 'change']
                        }
                    ],
                    repassword: [
                        { validator: validateRegisterRepassword, trigger: 'blur' }
                    ],
                    vcode: [
                        { required: true, message: '请输入验证码', trigger: 'blur' }
                    ]
                },
                vcodeIsSend: false,
                vcodeBtnText: '获取验证码',
                vcodeBtnLoading: false,
                registerBtnLoading: false,
            };
        },
        methods: {
            ...mapActions('user', ['Login']),
            changePage(type) {
                this.$emit('changePage', type);
            },
            handleGetVcode() {
                this.$refs.registerForm.validateField('email', err => {
                    if (!err) {
                        this.vcodeBtnText = '获取中';
                        this.vcodeBtnLoading = true;
                        getEmailCode({ email: this.register.email })
                            .then(({ code }) => {
                                if (code === 0) {
                                    this.vcodeIsSend = true;
                                }
                            })
                            .catch(() => {
                                this.vcodeIsSend = false;
                                this.vcodeBtnText = '获取验证码';
                            })
                            .finally(() => {
                                this.vcodeBtnLoading = false;
                            })
                    }
                });
            },
            handleRegister() {
                this.$refs.registerForm.validate(async valid => {
                    if (valid) {
                        if (!this.register.protocol) {
                            this.$message.error('只有接受协议才能继续进行注册');
                            return;
                        }
                        const params = {
                            email: this.register.email,
                            password: this.register.password,
                            code: this.register.vcode
                        };
                        this.registerBtnLoading = true;
                        try {
                            const { code } = await register(params);
                            if (code === 0) {
                                this.$message.success('注册成功');
                                const loginParams = {
                                    email: this.register.email,
                                    password: this.register.password
                                };
                                const res = await this.Login(loginParams);
                                localStorage.setItem("userId",res.data.id)
                                if (res.code === 0) {
                                    this.$store.dispatch('user/getUserInfo');
                                }
                                this.$emit('closeDialog');
                            }
                        } catch (e) {
                            this.vcodeIsSend = false;
                            this.vcodeBtnText = '获取验证码';
                        } finally {
                            this.registerBtnLoading = false;
                        }
                    }
                });
            },
        }
    };
</script>

<style lang="scss" scoped>
.register-content {
    &-title {
        margin-bottom: 10px;
        @include font(#1D2327, 20px, 600);
    }
    &-tip {
        margin-bottom: 25px;
        @include font(#999, 14px, 400);
    }
    .login__button {
        margin-top: 20px;
        text-align: center;
        text-decoration: underline;
        @include font(rgba(47, 84, 235, 1), 16px, 400);

        span {
            cursor: pointer;
        }
    }

    .login-form__item {
        // margin-bottom: 32px;
    }

    .protocol {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        transform: translateZ(0);
        @include font(rgba(44, 49, 74, 1), 14px, 400);

        a {
            @include font(rgba(90, 90, 90, 1), 14px, 400);
        }
    }
}
</style>
